import styles from './Spinner.module.scss';

export default function Spinner({ size = 'large' }: { size?: 'large' | 'small' }) {
  return <figure className={`${styles.wrapper} ${styles[size]}`}></figure>;
}
